import { CanDeactivateFn } from '@angular/router';
import { SettingsComponent } from '../settings/settings.component';

export const canDeactivateSettings: CanDeactivateFn<SettingsComponent> = (component) => {
  if (!component.hatUngespeicherteAenderungen()) return true;
  return component.confirmDeactivate();
};
